// CalendarView.tsx
import React from "react";
import CalendarHeader from "./CalendarHeader";
import CalendarBody from "./CalendarBody";

interface CalendarViewProps {
  teamMemberData: any; // Define the type of teamMemberData
  locationId: number;
}

const CalendarView: React.FC<CalendarViewProps> = ({
  teamMemberData,
  locationId,
}) => {
  const [selectedDate, setSelectedDate] = React.useState<Date>(new Date());
  return (
    <div className="tabs rounded-md  flex h-full flex-col  bg-[#EEF0FF] ">
      <CalendarHeader
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        locationId={locationId}
        teamMemberData={teamMemberData}
      />
      <CalendarBody
        selectedDate={selectedDate}
        locationId={locationId}
        teamMemberData={teamMemberData}
      />
    </div>
  );
};

export default CalendarView;
